<template>
    <Card>
        <template v-slot:title>
            {{ __('product.import_channel_products', {selectedChannel: selectedChannel}) }}
        </template>
        <template v-slot:description>
            {{ __('product.import_channel_products_title', {selectedChannel: selectedChannel}) }}
        </template>

        <div v-if="syncEnabled" class="d-flex flex-column gap-3">
            <div>
                <i class="fas fa-check text-success"/>
                {{ __('general.thing.is_enabled', {thing: __('general.synchronisation')}) }}
            </div>
            <div>
                <button class="btn btn-xs btn-secondary" @click="updateSyncEnabled(false)">
                    {{ __('actions.disable_thing', {thing: __('general.synchronisation')}) }}
                </button>
            </div>
        </div>
        <div v-else class="d-flex flex-column gap-2">
            <div>
                <i class="fas fa-times text-warning"/>
                {{ __('general.thing.is_disabled', {thing: __('general.synchronisation')}) }}
            </div>
            <div>
                <button class="btn btn-xs btn-secondary" @click="updateSyncEnabled(true)">
                    {{ __('actions.enable_thing', {thing: __('general.synchronisation')}) }}
                </button>
            </div>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card},

    props: {
        selectedChannel: String,
        syncEnabled: Boolean,
        store: Object
    },

    methods: {

        updateSyncEnabled(enabled) {
            this.$inertia.post(this.$route('store.articles.synchronisation', [this.store.id]), {
                integration_code: this.selectedChannel,
                enabled: enabled,
            }, {
                only: ['flash', 'syncEnabled'],
            })
        },
    }
}
</script>
